const BASE = process.env.REACT_APP_API_BASE_URL || '';

let _authToken = null;
try {
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);
  const hashToken = params.get('authToken');
  if (hashToken) _authToken = hashToken;
} catch {}
if (!_authToken) {
  try { _authToken = sessionStorage.getItem('authToken'); } catch {}
}
export function setAuthToken(token) {
  _authToken = token;
  try { sessionStorage.setItem('authToken', token); } catch {}
}
export function getAuthToken() { return _authToken; }

async function jsonFetch(path, init = {}) {
  const { body, headers, ...rest } = init;

  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    ...rest,
    headers: {
      ...(headers || {}),
      ...(body && !((headers || {})['Content-Type']) ? { 'Content-Type': 'application/json' } : {}),
      ...(_authToken ? { 'x-auth-token': _authToken } : {}),
    },
    body: body != null ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try { data = await res.json(); } catch { data = null; }

  if (!res.ok) {
    const msg = (data && (data.message || data.error)) || `Request failed: ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

export const API = {
  checkAuth: () => jsonFetch('/check-auth'),
  loginPortal: (portal) => jsonFetch(`/login?portal=${portal || ''}`),
  logout: () => jsonFetch('/logout', { method: 'POST' }),
  ping: () => jsonFetch('/ping'),

  fetchTimelogs: () => jsonFetch('/timelogs'),
  refreshTimelogs: () => jsonFetch('/timelogs?refresh=true'),
  createTimelog: (payload) => jsonFetch('/send-timelog', { method: 'POST', body: payload }),
  updateTimelog: (payload) => jsonFetch('/update-timelog', { method: 'PUT', body: payload }),
  deleteTimelog: (payload) => jsonFetch('/delete-timelog', { method: 'DELETE', body: payload }),

  searchAccounts: (query) =>
    jsonFetch(`/search-accounts?q=${encodeURIComponent(query)}`),
  fetchAccountProjects: (accountId) =>
    jsonFetch(`/account-projects?accountId=${encodeURIComponent(accountId)}`),
  fetchWorktypes: () => jsonFetch('/worktypes'),

  getUserViewPreference: () => jsonFetch('/user/view-preference'),
  saveUserViewPreference: (view) => jsonFetch('/user/view-preference', { method: 'POST', body: { view } }),
};
